import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MetersRoutingModule } from './meters-routing.module';
import { RpMetersComponent } from './rp-meters/rp-meters.component';
import { RpMetersViewComponent } from './rp-meters-view/rp-meters-view.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import {
  GridModule,
  PDFModule,
  ExcelModule,
} from '@progress/kendo-angular-grid';
import { TextBoxModule } from '@progress/kendo-angular-inputs';
import { ModalModule } from 'ngx-bootstrap/modal';
import { UiSwitchModule } from 'ngx-ui-switch';
import { ComponentsModule } from '../../shared/components/components.module';
import { SharedModule } from '../../shared/shared.module';
import { NgStepperModule } from 'angular-ng-stepper';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { MetersDatabaseComponent } from './meters-database/meters-database.component';
import { EditMetersComponent } from './edit-meters/edit-meters.component';
import { UploadsModule } from '@progress/kendo-angular-upload';
@NgModule({
  declarations: [RpMetersComponent, RpMetersViewComponent, MetersDatabaseComponent, EditMetersComponent],
  imports: [
    CommonModule,
    MetersRoutingModule,
    NgSelectModule,
    BsDatepickerModule,
    GridModule,
    PDFModule,
    ExcelModule,
    TextBoxModule,
    ModalModule,
    UiSwitchModule,
    ComponentsModule,
    SharedModule,
    NgStepperModule,
    CdkStepperModule,UploadsModule
  ],
})
export class MetersModule {}
